// Chat measurements contain counts only. Message ids stay in bounded page memory for exposure deduplication.
export function createChatActivity({ now = () => performance.now(), emit }) {
  let city = null, since = 0, viewed = 0;
  const seen = new Set();
  function flush(reason, exit = false) {
    if (!city) return;
    const at = now(), seconds = Math.max(0, at - since) / 1000;
    if (seconds > 0 || viewed) emit({ city, visible_s: seconds, messages_viewed: viewed, reason }, exit);
    since = at;
    viewed = 0;
  }
  return {
    update(next, reason = 'interval', exit = false) {
      if (next !== city) {
        flush(reason, exit);
        city = next;
        since = now();
      } else if (city && now() - since >= 60000) flush('interval');
    },
    view(ids) {
      if (!city) return;
      for (const id of ids) {
        if (!Number.isSafeInteger(id)) continue;
        const key = `${city}:${id}`;
        if (seen.has(key)) continue;
        seen.add(key);
        viewed++;
        if (seen.size > 4096) seen.delete(seen.values().next().value);
      }
    },
    flush,
  };
}

/** A row must have at least half its height visible inside both the log and the browser viewport. */
export function messageVisible(row, log, viewportHeight) {
  const height = Math.min(row.bottom, log.bottom, viewportHeight) - Math.max(row.top, log.top, 0);
  return row.height > 0 && height >= row.height / 2;
}

/** Validate shared server snapshots, and flatten only the current city's counts for PostHog. Never sum snapshots. */
export function chatSnapshot(m, city) {
  const count = n => Number.isSafeInteger(n) && n >= 0;
  if (!city || !m || !count(m.messages?.total) || !count(m.viewers?.total) || !count(m.messages?.since)) return null;
  const messages = m.messages.cities?.[city] ?? 0, viewers = m.viewers.cities?.[city] ?? 0;
  if (!count(messages) || !count(viewers) || messages > m.messages.total || viewers > m.viewers.total) return null;
  return { city, messages_total: m.messages.total, city_messages_total: messages,
    viewers_now: m.viewers.total, city_viewers_now: viewers, counting_since: m.messages.since };
}
